import React, { useState, useEffect } from "react";
import {useParams, useHistory, useLocation} from "react-router-dom";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import { APP_STATUS, TOAST_TYPES } from "../../utils/constants";
import { getApplicationAlignmentService, getApplicationService } from "../../services/app.service";
import { ONLINE_SYSTEM_MAP } from "../../utils/META/cat_117";
import {postAddAssessmentReq} from "../../services/certify.service";
import {toast} from "../../utils/utils";
import {
    fetchRatingProgramStatusService,
    enableAssessmentService, publishProgramAssessmentService,
} from "../../services/rating.service";
import RatingSelectAssessmentView from "../../views/ver_24.10/ProgramRating/RatingSelectAssessment.view";
import {ASSESSMENT_STEPS} from "../../utils/RatingFlowSteps";

const RatingSelectAssessmentPage = () => {
    const { programId } = useParams();
    const history = useHistory();
    const location = useLocation();
    const [orgCode, setOrgCode] = useState(false);
    const application_id = programId;
    const [appData, setAppData] = useState();
    const [status, setStatus] = useState(null);
    const [programStatusV3, setProgramStatusV3] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [submittedFormData, setSubmittedFormData] = useState(null);
    const [isAppAligned, setIsAppAligned] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const [selectedAssessment, setSelectedAssessment] = useState(null);
    //state for stepper
    const [currentStatus, setCurrentStatus] = useState(APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED);


    const [formData, setFormData] = useState({
        noOfUsers: '',
        onlineSystem: '',
        requirements: '',
        nameOfCountries: '',
        onlinePlatformDesc:'',
        callBackUrl:'To be Decided',
        callBackKey:'To be Decided',
        requirementDesc:'',

    });

    const key_desc = {
        assessmentType: "Type of Assessment",
        noOfUsers: "Expected number of users",
        onlineSystem: "Delivery mode of assessment",
        callBackUrl: "Call Back URL",
        callBackKey: "Call Back Key",
        requirements:"Details of requirements",
        requirementDesc:"Description of requirements",
        nameOfCountries: "Target Countries"
    }
    const getAssessmentTypeLabel = (value) => {
        switch (value) {
            case 1:
                return 'DQ Selected Pre and Post Assessment';
            case 2:
                return 'DQ Selected Post Assessment Only';
            case 3:
                return 'Digital Citizenship Test';
            case 4:
                return 'Digital Parenting Test';
            case 5:
                return 'Custom Pre and Post Assessment';
            case 6:
                return 'Custom Post Assessment Only';
            default:
                return ' ';
        }
    };
    const loadAppData = async () => {
        try {
            setShowLoader(true);
            const result = await getApplicationService(programId);
            if (!result.error && result.data) {
                setAppData(result.data);
                setStatus(result.data.app_status);
                if (result.data.assessments_approve_info?.org_code) {
                    setOrgCode(result.data.assessments_approve_info.org_code);
                }
                if (result.data.app_status === APP_STATUS.ASSESSMENTS_READY) {
                    setCurrentStatus('PREVIEW_ASSESS');
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setShowLoader(false);
        }
    };

    useEffect(() => {
        console.log('programId:', programId);
        loadAppData().then((res) => `fetch initiated, ${res}`);
    }, []);

    const fetchRatingProgram = async () => {
        try {
            setShowLoader(true);
            const result = await fetchRatingProgramStatusService(programId);
            if (result.data) {
                setStatus(result.data.app_status);
                setProgramStatusV3(result.data.app_status_v3);
                if (
                    result.data.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED
                ) {
                    history.push(`/rating/${programId}`);
                }
            }
        } catch (error) {
            console.error('Error fetching program:', error);
            setShowLoader(false);
        } finally {
            setShowLoader(false);
        }
    };

    useEffect(() => {
        fetchRatingProgram().then(r => console.log(r));
    }, [programId]);

    const updateDQSealType = async () => {
        if (status === APP_STATUS.COMPLETED) {
            try {
                setShowLoader(true);
                const result = await enableAssessmentService(application_id);
                if (result && result.data.program_application && !result.error) {
                    setAppData(result.data.program_application);
                    setStatus(result.data.program_application.app_status)
                }
            } catch (error) {
                console.error(error);
                setShowLoader(false);
            } finally {
                setShowLoader(false);
            }
        }
    }

    useEffect(() => {
        updateDQSealType().then(r => console.log('aj: appData ', appData));
    }, [application_id, status]);

    const fetchData = async () => {
        if (status > APP_STATUS.READY_TO_CERTIFY) {
            try {
                setShowLoader(true);
                const result = await getApplicationService(application_id);
                const onlineSystem = ONLINE_SYSTEM_MAP[result.data.assessment_req_info.client_own_platform_info]?.label || result.data.assessment_req_info.client_own_platform_info;
                const assessmentTypeLabel = getAssessmentTypeLabel(result.data.assessment_req_info.assess_type);
                if (result && result.data.assessment_req_info && !result.error) {
                    const postedData = {
                        assessmentType: assessmentTypeLabel,
                        noOfUsers: result.data.assessment_req_info.expected_users,
                        onlineSystem: onlineSystem,
                        callBackUrl: result.data.assessment_req_info.client_own_callback_url,
                        callBackKey: result.data.assessment_req_info.client_own_callback_key
                    };
                    setSubmittedFormData(postedData);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setShowLoader(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [application_id, status]);

    useEffect(() => {
        const getAppAlignment = async () => {
            if (status >= APP_STATUS.READY_TO_CERTIFY) {
                try {
                    setShowLoader(true);
                    const result = await getApplicationAlignmentService(application_id);
                    if (result && result.data && !result.error) {
                        setIsAppAligned(result.data.length > 0)
                    }
                    else {
                        console.log('No data exists or error fetching data');
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setShowLoader(false);
                }
            }
        };

        getAppAlignment().then(r=> console.log(r));
    }, [application_id, status]);

    const validateForm = () => {
        if (!formData.noOfUsers) {
            toast(TOAST_TYPES.ERROR, "Error", "Please enter number of users");
            return false;
        }
        if (!formData.nameOfCountries) {
            toast(TOAST_TYPES.ERROR, "Error", "Please enter target countries");
            return false;
        }
        return true;
    };


    const submitAddAssessmentReqAction = async () => {

        const postData = {
            'application_id': application_id,
            'assess_type': selectedCard,
            'expected_users': formData.noOfUsers,
            'client_own_platform_info': "yes", // Default value
            'client_own_callback_url': "To be Decided", // Default value
            'client_own_callback_key': "To be Decided", // Default value
            // 'client_own_platform_info_desc': formData.onlinePlatformDesc.length > 0 ? formData.onlinePlatformDesc : '',
            'client_requirements_info': "no", // Default value
            'client_requirements_info_desc': "",
            'intended_name_of_countries': formData.nameOfCountries
        }

        try {
            setShowLoader(true);
            const result = await postAddAssessmentReq(postData);
            if (!result.error) {
                toast(TOAST_TYPES.SUCCESS, "Request Submitted", "Successfully submitted request, we will contact you back soon.")
                if (result.data.success) {
                    setStatus(result.data.status)
                }
            }
            setShowLoader(false);
        }
        catch (e) {
            setShowLoader(false);
            //already toasted
        }
        // make the post call to => /certify/assessment/request
    }

    const formSubmitAction = (formData) => {
        setSubmittedFormData(formData);
    }


    const selectedCardAction = (selectedCardValue) => {
        setSelectedAssessment(selectedCardValue);
    };

    const cardClickAction = (buttonIndex) => {
        if (selectedCard === buttonIndex) {
            setSelectedCard(null);
            setShowForm(false);
            setCurrentStatus('ASSESS_ROLLOUT');

        } else {
            setSelectedCard(buttonIndex);
            setShowForm(true);
            setCurrentStatus('ASSESS_ROLLOUT');
        }

        selectedCardAction(buttonIndex);
    };

    const accessAssessmentAction = (programId, program_status) => {
        if (program_status >= APP_STATUS.ASSESSMENTS_READY) {
            history.push({
                pathname: `/rating/${programId}/access_assessment`,
                state: { currentStatus: 'ACCESS_ASSESS_DASH' }
            });
        } else {
            history.push({
                pathname: `/rating/${programId}/select_assessment`,
                state: { currentStatus: APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED }
            });

        }
    };

    const handleNextToPublish = () => {
        setCurrentStatus('PUBLISH_ASSESS');
    };

    const publishAssessmentAction = async () => {
        try {
            setShowLoader(true);
            const result = await publishProgramAssessmentService(programId)
            if (!result.error && result.data) {
                setAppData(result.data.program_application);
                setStatus(result.data.program_application.app_status);
                toast(TOAST_TYPES.SUCCESS, "Published", "Assessments Successfully Published");
            }
            if(APP_STATUS.ASSESSMENTS_PUBLISHED){
                setCurrentStatus('ACCESS_ASSESS_DASH');
            }
        } catch (error) {

        } finally {
            setShowLoader(false);
        }
    }

    const goToDqAssessAction = () => {
        if (appData && appData.assessments_approve_info) {
            const username_q = appData.assessments_approve_info.demo_dq_assess_user;
            const password_q = appData.assessments_approve_info.demo_dq_assess_pass;
            window.open(`${process.env.REACT_APP_MYDQ_APP_LOGIN_URL}?username=${username_q}&password=${password_q}`, '_blank');
        } else {
            window.open(process.env.REACT_APP_MYDQ_APP_LOGIN_URL, '_blank');
        }
    }

    const options = {
        showLoader,
        isAppAligned,
        selectedCard,
        showForm,
    };

    const actions = {
        formSubmitAction,
        submitAddAssessmentReqAction,
        cardClickAction,
        selectedCardAction,
        accessAssessmentAction,
        publishAssessmentAction,
        goToDqAssessAction,
        setStatus,
        setCurrentStatus,
        handleNextToPublish
    };

    const data = {
        application_id,
        status,
        submittedFormData,
        key_desc,
        formData,
        setFormData,
        ASSESSMENT_STEPS,
        currentStatus,
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <RatingSelectAssessmentView
            options={options}
            actions={actions}
            data={data}
        />
    );
};

export default RatingSelectAssessmentPage;